/** -----------------------------------------------------------------------------
 * App
 *
 * Renders the TrueHack X countdown interface defined in public/index.html
 * The HTML structure is static; React mounts to the #root div without adding
 * additional components, allowing the DOM structure and styles to work as-is.
 * ------------------------------------------------------------------------------- */

export default function App() {
  return <></>;
}

/** 

import Counter from './components/counter';
import './truehack.scss';
import { ReactComponent as TLMark } from './assets/tl-mark.svg';

export default function App() {
  return (
    <section className="container">
      <TLMark className="tl-mark" />
      <Counter />
    </section>
  );
}
  
**/
